module.exports = __webpack_public_path__ + "img/profile1.8e973a6d.jpeg";